import React from "react";
import { theme } from 'src/config/theme';

export const MembershipIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => (

<svg xmlns="http://www.w3.org/2000/svg" 
height="24px" 
viewBox="0 0 24 24" 
width="24px" 
fill={theme.color.black}>
<path d="M0 0h24v24H0V0z" 
fill="none"/>
<path d="M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V5c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v5z"/>
</svg>

);